import { c as _c } from "react/compiler-runtime";
import ViverseButton from '@/components/ViverseButton';
import { useTranslations } from 'next-intl';
type EnterFullscreenModalProps = {
  onConfirm: () => void;
};
function EnterFullscreenModal(t0) {
  const $ = _c(19);
  const {
    onConfirm
  } = t0;
  const t = useTranslations();
  let t1;
  if ($[0] !== t) {
    t1 = t("enter-fullscreen-modal.title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <p className="subheader-1 w-full text-center">{t1}</p>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("enter-fullscreen-modal.description");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <p className="body-2 font-vive-primary-60 w-full">{t3}</p>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <div className="flex w-full flex-col items-center gap-3">{t2}{t4}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("assign-result-message.login-button");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== onConfirm || $[14] !== t6) {
    t7 = <ViverseButton variant="outline" size="custom" className="h-10 w-[152px]" onClick={onConfirm}>{t6}</ViverseButton>;
    $[13] = onConfirm;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t5 || $[17] !== t7) {
    t8 = <div className="absolute inset-0 z-navigation flex items-center justify-center bg-black/60"><div className="border-vive-primary-70 bg-vive-popup flex w-[312px] flex-col items-center gap-5 rounded-lg border-2 p-6">{t5}{t7}</div></div>;
    $[16] = t5;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}
export default EnterFullscreenModal;